const type = {
  NONE: 0,
  GOODS: 1,
  SHOP: 2
};

export default type;
